import { createAsyncAction } from '../helpers';

export const getContentAsyncAction = createAsyncAction('GET_CONTENT');

export const getContactUsAsyncAction = createAsyncAction('GET_CONTACT_US');
